import React, { Component } from 'react';
import _ from 'lodash';

import {
    Card,
    CardBody,
    CardHeader,
    Collapse,
    FormGroup,
    Input,
    Label
} from 'reactstrap';

import qs from 'qs';
import { withRouter } from 'react-router-dom';

import CollapseButton from '../dumb/collapseButton';
import baseFilter from './baseFilter';

class MolecularSubtypeFilter extends baseFilter {

    constructor(props) {
        super(props);

        this.toggleCheckbox =
            this.toggleCheckbox.bind(this);

        this.updateAPIURL =
            this.updateAPIURL.bind(this);

        this.processResponse =
            this.processResponse.bind(this);

        this.toggleCollapse =
            this.toggleCollapse.bind(this);

        this.state = {
            filters: {
                cris: {
                    active: false,
                    count: null
                },
                cms: {
                    active: false,
                    count: null
                }
            },

            isOpen: false,
            activeCount: 0
        };

        this.aggregates = {
            'cris_prediction': 'count',
            'cms_prediction': 'count'
        };
    }

    static getDerivedStateFromProps(
        newprops,
        oldstate
    ) {
        const current_qs = qs.parse(
            newprops.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        const activeFilters = (
            'molecular_subtype' in current_qs
                ? _.split(
                    current_qs.molecular_subtype,
                    '__'
                )
                : []
        );

        return {
            filters: {
                cris: {
                    ...oldstate.filters.cris,
                    active:
                        activeFilters.indexOf(
                            'cris'
                        ) >= 0
                },

                cms: {
                    ...oldstate.filters.cms,
                    active:
                        activeFilters.indexOf(
                            'cms'
                        ) >= 0
                }
            },

            activeCount: [
                'cris',
                'cms'
            ].filter(
                key =>
                    activeFilters.indexOf(key) >= 0
            ).length
        };
    }

    toggleCollapse() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    toggleCheckbox(event) {
        const {
            name,
            checked
        } = event.target;

        const current_qs = qs.parse(
            window.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        let active = (
            'molecular_subtype' in current_qs
                ? _.split(
                    current_qs.molecular_subtype,
                    '__'
                )
                : []
        );

        if (checked) {
            if (active.indexOf(name) === -1) {
                active.push(name);
            }
        } else {
            active = active.filter(
                item => item !== name
            );
        }

        current_qs.molecular_subtype =
            active.length > 0
                ? _.join(
                    active.sort(),
                    '__'
                )
                : undefined;

        current_qs.page = undefined;

        this.props.history.push(
            window.location.pathname +
            qs.stringify(
                current_qs,
                {
                    addQueryPrefix: true
                }
            )
        );
    }

    updateAPIURL(
        api_qs,
        newlistprops
    ) {
        const current_qs = qs.parse(
            newlistprops.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        const activeFilters = (
            'molecular_subtype' in current_qs
                ? _.split(
                    current_qs.molecular_subtype,
                    '__'
                )
                : []
        );

        let filters =
            _.get(api_qs, 'filter', []);

        if (
            activeFilters.indexOf('cris') >= 0
        ) {
            filters = filters
                .concat({
                    name: 'cris_prediction',
                    op: 'ne',
                    val: null
                })
                .concat({
                    name: 'cris_prediction',
                    op: 'ne',
                    val: 'Unclassified'
                });
        }

        if (
            activeFilters.indexOf('cms') >= 0
        ) {
            filters = filters
                .concat({
                    name: 'cms_prediction',
                    op: 'ne',
                    val: null
                })
                .concat({
                    name: 'cms_prediction',
                    op: 'ne',
                    val: 'Unclassified'
                });
        }

        if (filters.length > 0) {
            api_qs.filter = filters;
        }

        return _.merge(api_qs, {
            agg: this.aggregates
        });
    }

    getCountFromResponse(
        response,
        field
    ) {
        const basePath =
            `meta.agg.${field}`;

        const counts = _.get(
            response,
            `${basePath}.count`
        );

        if (!counts) {
            return 0;
        }

        return _.reduce(
            counts,
            (sum, count, key) => {

                if (
                    key !== 'None' &&
                    key !== 'null' &&
                    key !== 'Unclassified'
                ) {
                    return sum + count;
                }

                return sum;
            },
            0
        );
    }

    processResponse(response) {
        this.setState({
            filters: {
                cris: {
                    ...this.state.filters.cris,
                    count:
                        this.getCountFromResponse(
                            response,
                            'cris_prediction'
                        )
                },

                cms: {
                    ...this.state.filters.cms,
                    count:
                        this.getCountFromResponse(
                            response,
                            'cms_prediction'
                        )
                }
            }
        });
    }

    componentDidMount() {
        this.props.registerResponse(
            this.processResponse
        );

        this.props.registerRequest(
            this.updateAPIURL
        );
    }

    componentWillUnmount() {
        this.props.unregisterResponse(
            this.processResponse
        );

        this.props.unregisterRequest(
            this.updateAPIURL
        );
    }

    render() {
        const {
            filters,
            isOpen,
            activeCount
        } = this.state;

        return (
            <Card className="genetic-filters mb-2 z0 hover">

                <CardHeader
                    className="justify-content-between d-flex"
                    onClick={this.toggleCollapse}
                >
                    <div className="d-inline w-50">
                        Molecular Subtype
                    </div>

                    <div className="d-inline-block">
                        {activeCount > 0 && (
                            <strong>
                                {activeCount + ' active'}
                            </strong>
                        )}
                    </div>

                    <CollapseButton
                        isOpen={isOpen}
                        onClick={this.toggleCollapse}
                    />
                </CardHeader>

                <Collapse isOpen={isOpen}>
                    <CardBody>

                        {['cris', 'cms'].map(
                            key => (
                                <FormGroup
                                    check
                                    key={key}
                                >
                                    <Input
                                        type="checkbox"
                                        name={key}
                                        onChange={
                                            this.toggleCheckbox
                                        }
                                        checked={_.get(
                                            filters[key],
                                            'active',
                                            false
                                        )}
                                    />{' '}

                                    <Label
                                        className="ml-4 mt-1"
                                        check
                                    >
                                        {key.toUpperCase()}

                                        {filters[key].count !== null &&
                                            filters[key].count !== undefined && (
                                                <span className="secondary">
                                                    {' '}(
                                                    {filters[key].count}
                                                    )
                                                </span>
                                            )}
                                    </Label>
                                </FormGroup>
                            )
                        )}

                    </CardBody>
                </Collapse>

            </Card>
        );
    }
}

export default withRouter(
    MolecularSubtypeFilter
);